import React, { useEffect, useState } from "react";
import styles from "../Profile/Profile.module.css";
import { deleteProfileVideo } from "../../context/apiCalls/apiCalls";
import deleteOpen from "../../assests/popup/deleteOpen.svg";
import LoadingFromCenter from "../LoadingFromCenter/LoadingFromCenter";
function DeleteModel({
  setShowDelete,
  singleFileDetails,
  token,
  profileContent,
  setShowPreview,
}) {
  const campaignId = singleFileDetails?.campaignId;
  const contestId = singleFileDetails?.contestId;
  const videoId = singleFileDetails?._id;
  const orgId = singleFileDetails?.orgId;
  const [deleteNavigation, setDeleteNavigation] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const handleDelete = () => {
    deleteProfileVideo(
      campaignId,
      contestId,
      videoId,
      token,
      profileContent,
      setShowPreview,
      setShowDelete,
      orgId,
      setDeleteLoading,
      deleteReason
    );
    if (deleteNavigation) {
      setShowPreview(false);
      setShowDelete(false);
    }
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const [deleteReason, setDeleteReason] = useState("");
  const handleInputChange = (e) => {
    setDeleteReason(e.target.value);
  };
  return (
    <div className="popupBackground fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center z-10">
      <div className={styles.deteleme}>
        <img src={deleteOpen} alt="" className="w-[56px] h-[56px] mb-[24px]" />
        <p className="text-regular-medium px-[20px] mb-[16px]">
          Are you sure want to delete your participation?
        </p>
        <p className="text-small text-[#CDCDCD] px-[20px] mb-[16px]">
          You can’t undo this action
        </p>
        <div className="flex flex-col gap-[10px] text-small w-full">
          <textarea
            type="text"
            value={deleteReason}
            placeholder="Could you kindly share the reason for deleting your entry?"
            onChange={handleInputChange}
            className={styles.textarea}
          />
        </div>
        <div className="seperator my-[20px]" />
        <div className="flex flex-col gap-[16px] w-[100%] cursor-pointer">
          <button
            className={styles.Deeleeete}
            onClick={() => handleDelete()}
            disabled={deleteLoading}
          >
            <p className="text-regular-medium ">Delete</p>
          </button>
          <div onClick={() => setShowDelete(false)}>
            <p>Cancel</p>
          </div>
        </div>
        {deleteLoading && <LoadingFromCenter />}
      </div>
    </div>
  );
}

export default DeleteModel;
